/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Set_Already_ExistsInputs */

const en_us2_workout_set_already_exists = /** @type {(inputs: Workout_Set_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This set was already logged.`)
};

const pt_br2_workout_set_already_exists = /** @type {(inputs: Workout_Set_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta série já foi registrada.`)
};

const es_419_workout_set_already_exists = /** @type {(inputs: Workout_Set_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta serie ya estaba registrada.`)
};

const pt_pt2_workout_set_already_exists = /** @type {(inputs: Workout_Set_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta série já foi registada.`)
};

const fr_fr2_workout_set_already_exists = /** @type {(inputs: Workout_Set_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette série a déjà été enregistrée.`)
};

const de_de2_workout_set_already_exists = /** @type {(inputs: Workout_Set_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Satz wurde bereits eingetragen.`)
};

const it_it2_workout_set_already_exists = /** @type {(inputs: Workout_Set_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa serie è già stata registrata.`)
};

/**
* | output |
* | --- |
* | "This set was already logged." |
*
* @param {Workout_Set_Already_ExistsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_set_already_exists = /** @type {((inputs?: Workout_Set_Already_ExistsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Set_Already_ExistsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_set_already_exists(inputs)
	if (locale === "es-419") return es_419_workout_set_already_exists(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_set_already_exists(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_set_already_exists(inputs)
	if (locale === "de-DE") return de_de2_workout_set_already_exists(inputs)
	if (locale === "it-IT") return it_it2_workout_set_already_exists(inputs)
	return en_us2_workout_set_already_exists(inputs)
});
export { workout_set_already_exists as "workout.set_already_exists" }